import { apiClient } from './client'
import { UpdateFileParams, UpdateFileResponse } from './globalTypes'

export const updateFile = async (params: UpdateFileParams) => {
    const { id, ...data } = params

    const response = await apiClient(`v1/file/${id}`, {
        method: 'PUT',
        data,
    })

    return response as UpdateFileResponse
}

export const downloadFile = async (fileId: string, fileName: string) => {
    const response = await apiClient(`v1/file/download/${fileId}`, {
        method: 'GET',
        responseType: 'blob',
    })

    const blob = response.data
    triggerDownload(fileId, blob, fileName)
}

export const triggerDownload = (id: number | string, blob: Blob, fileName: string) => {
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = fileName || `file_${id}`

    document.body.appendChild(link)
    link.click()

    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
}
